export const id = {
    translation: {
        common: {
            trial: "Versi Uji Coba",
            expired: "Kadaluarsa",
            renewal: "Perpanjangan",
            quantity: "Jml",
            error: "Kesalahan",
            all: "Semua",
            loading: "Memuat...",
            thank_you: "Terima Kasih",
            confirm: "Konfirmasi",
            cancel: "Batal",
            save: "Simpan",
            add: "Tambah",
            edit: "Ubah",
            delete: "Hapus",
            warning: "Peringatan",
            delete_confirm_text: "Tindakan ini tidak dapat dibatalkan. Apakah Anda yakin ingin menghapus?",
            click_to_select: "Pilih...",
            unit: "Satuan",
            detail: "Detail",
            done: "Selesai",
            search: "Cari",
            processing: "Memproses...",
            success: "Berhasil",
            total: "Total",
            none: "Tidak Ada"
        },
        roles: {
            admin: "Admin",
            barista: "Barista",
            waiter: "Pelayan",
            kitchen: "Dapur"
        },
        auth: {
            user_not_found: "Pengguna tidak ditemukan!",
            welcome: "Selamat Datang Kembali",
            subtitle: "Masuk untuk mengelola kedai kopi Anda",
            google_login: "Masuk dengan Google",
            apple_login: "Masuk dengan Apple",
            secure_login: "Login Aman",
            terms_text: "Dengan masuk, Anda menyetujui Ketentuan Layanan dan Kebijakan Privasi kami."
        },
        sidebar: {
            dashboard: "Dasbor",
            tables: "Meja",
            staff: "Staf",
            loyalty: "CRM & Loyalitas",
            qr_menu: "Menu QR",
            menu_product: "Menu & Produk",
            stock_recipe: "Stok & Resep",
            reports: "Laporan",
            settings: "Pengaturan",
            admin_panel: "Panel Admin",
            not_logged_in: "Belum Masuk",
            click_to_select: "Pilih Profil",
            switch_profile: "Ganti Profil",
            logout: "Keluar"
        },
        dashboard: {
            overview: "Ikhtisar Dasbor",
            today: "Hari Ini",
            system_active: "Sistem Aktif",
            offline: "Mode Luring",
            payment_reminder: "Pengingat Pembayaran",
            payment_missing_list: "Pembayaran untuk {{names}} belum dilakukan.",
            add_expense: "Tambah Biaya",
            daily_revenue: "Pendapatan Harian",
            open_tables: "Meja Terbuka",
            pending_tables: "Pesanan Tertunda",
            waiting_approval: "Menunggu Persetujuan",
            active_staff: "Staf Aktif",
            hourly_revenue: "Pendapatan Per Jam",
            hourly_profit: "Laba Per Jam",
            work_hours: "Jam Kerja",
            hours_24: "24 Jam",
            revenue: "Pendapatan",
            profit: "Laba",
            best_sellers: "Terlaris",
            support_modal: { other: "Lainnya" },
            weekly_performance: "Performa Mingguan",
            weekly_revenue: "Pendapatan Mingguan",
            increase: "Kenaikan",
            decrease: "Penurunan",
            busiest_day: "Hari Teramai",
            view_report: "Lihat Laporan",
            critical_stock_warning: "Stok Kritis",
            quick_actions: "Tindakan Cepat",
            x_report: "Laporan X",
            sync: "Sinkronisasi",
            backup: "Cadangan",
            support: "Dukungan",
            help_support: "Bantuan & Dukungan",
            help_desc: "Bagaimana kami bisa membantu Anda?",
            report_issue: "Laporkan Masalah",
            version: "Versi",
            topic: "Topik",
            technical: "Masalah Teknis",
            suggestion: "Saran",
            other: "Lainnya",
            description: "Deskripsi",
            desc_placeholder: "Mohon jelaskan masalahnya...",
            send_report: "Kirim Laporan"
        },
        tables: {
            status: {
                occupied: "Terisi",
                paid: "Dibayar",
                reserved: "Dipesan",
                empty: "Kosong"
            },
            alerts: {
                reservation_time: "Waktu Reservasi:",
                draft_paid: "Draft Pesanan Dibayar",
                draft_unpaid: "Draft Pesanan"
            },
            title: "Denah Meja",
            tabs: {
                plan: "Denah",
                history: "Riwayat"
            },
            filter: {
                all: "Semua"
            },
            actions: {
                finish_edit: "Selesai Mengubah",
                edit: "Ubah Meja",
                add_table: "Tambah Meja",
                quick_pay: "Bayar Cepat",
                reserve: "Pesan",
                clear: "Kosongkan"
            },
            card: {
                capacity: "Orang",
                just_now: "Baru saja",
                total: "Total",
                has_request: "Permintaan Baru",
                no_order: "Tanpa Pesanan"
            },
            history: {
                search_placeholder: "Cari No Tiket atau Meja...",
                multi_pay: "Bayar Sekaligus"
            },
            sections: {
                manage: "Kelola Bagian",
                add_placeholder: "Nama Bagian Baru",
                no_sections: "Tidak ada bagian yang ditentukan."
            },
            modal: {
                edit_title: "Ubah Meja",
                add_title: "Tambah Meja",
                name: "Nama Meja",
                name_placeholder: "misal: Meja 5",
                section: "Bagian",
                capacity: "Kapasitas",
                delete: "Hapus Meja",
                unpaid_warning_title: "Saldo Belum Dibayar!",
                clear_confirm_title: "Kosongkan Meja?",
                unpaid_warning_text: "<b>{{name}}</b> memiliki saldo yang belum dibayar. Mengosongkannya akan mengatur ulang pesanan.",
                clear_confirm_text: "Apakah Anda yakin ingin mengosongkan <b>{{name}}</b>?",
                delete_confirm_text: "Apakah Anda yakin ingin menghapus <b>{{name}}</b>?"
            },
            qr_review: {
                title: "Pesanan QR Masuk",
                subtitle: "Permintaan baru dari {{name}}",
                current_state: "Status Meja Saat Ini",
                table_empty: "Meja saat ini kosong.",
                current_total: "Total Saat Ini",
                incoming_request: "Permintaan Masuk",
                extra_total: "Total Tambahan",
                reject: "Tolak",
                overwrite: "Ganti Semua",
                overwrite_desc: "Hapus yang lama & set baru",
                merge: "Gabungkan",
                merge_desc: "Tambahkan ke yang sudah ada"
            }
        },
        orders: {
            status: {
                completed: "Selesai"
            },
            list: {
                ticket_no: "No Tiket",
                date: "Tanggal/Waktu",
                table: "Meja/Pelanggan",
                method: "Metode",
                amount: "Jumlah",
                status: "Status"
            },
            modal: {
                match_error: "Total pembayaran ({{pay}}₺) tidak sesuai dengan total pesanan ({{total}}₺).",
                title: "Detail Transaksi",
                content_title: "Isi Pesanan",
                total_title: "Total Jumlah",
                payment_details: "Detail Pembayaran",
                entered_total: "Total yang Dimasukkan",
                difference: "Selisih"
            },
            correction: {
                note_placeholder: "misal: Salah input oleh staf"
            },
            void_flow: {
                button_update: "Update Status / Void",
                button_void: "Void / Pengembalian",
                title_select: "Pilih Tipe Void",
                type_cancel: "Kesalahan / Kembali",
                type_cancel_desc: "Mengembalikan Stok",
                type_wastage: "Pembuangan / Tumpah",
                type_wastage_desc: "Mengurangi Stok (Tanpa Kembali)",
                confirm_cancel_title: "Tandai sebagai Kesalahan/Kembali",
                confirm_wastage_title: "Tandai sebagai Pembuangan",
                confirm_cancel_text: "Ini akan membatalkan penjualan dan mengembalikan semua stok ke inventaris. Anda yakin?",
                confirm_wastage_text: "Ini akan membatalkan penjualan tetapi stok akan dianggap TERPAKAI/HILANG. Anda yakin?",
                confirm: "KONFIRMASI"
            }
        },
        pos: {
            title_quick: "Pesanan Cepat",
            title_no_table: "Tanpa Meja",
            title_table: "{{name}}",
            search_placeholder: "Cari Produk...",
            grid: {
                sold_out: "HABIS"
            },
            ticket: {
                title: "Tiket Saat Ini",
                order_no: "NO PESANAN",
                new: "BARU",
                empty: "Keranjang kosong.",
                status: {
                    wastage: "PEMBUANGAN",
                    comp: "GRATIS",
                    cancelled: "DIBATALKAN",
                    paid: "DIBAYAR"
                },
                discount_badge: "POTONGAN"
            },
            actions: {
                discount: "DISKON",
                comp: "GRATIS",
                void: "BUANG",
                cancel: "BATAL",
                pay: "BAYAR",
                assign_table: "MEJA",
                save: "SIMPAN",
                waiting_payment: "MENUNGGU PEMBAYARAN",
                close_ticket: "TUTUP TIKET"
            },
            totals: {
                subtotal_net: "Subtotal (Net)",
                tax_vat: "Pajak (PPN)",
                grand_total: "Total Keseluruhan",
                tax_exclusive_hint: "(+Pajak)"
            },
            alerts: {
                table_not_found: "Meja tidak ditemukan.",
                perm_comp: "Anda tidak memiliki izin untuk memberikan barang gratis.",
                perm_void: "Anda tidak memiliki izin untuk melakukan void barang.",
                select_item_error: "Silakan pilih barang.",
                paid_item_error: "Barang yang sudah dibayar tidak dapat diubah.",
                split_quantity: "Berapa banyak dari {{count}} barang yang akan dipindahkan?",
                invalid_amount: "Jumlah tidak valid.",
                perm_discount: "Anda tidak memiliki izin untuk menerapkan diskon.",
                select_discount_item: "Pilih barang untuk didiskon.",
                paid_discount_error: "Tidak dapat mendiskon barang yang sudah dibayar.",
                add_items_first: "Silakan tambahkan barang ke keranjang terlebih dahulu.",
                unauthorized: "Akses Ditolak"
            },
            modifier_modal: {
                no_modifiers: "Tidak ada modifikasi yang tersedia.",
                multiple: "beberapa",
                add_to_cart: "Tambah ke Keranjang"
            },
            discount_modal: {
                title: "Terapkan Diskon",
                percent: "Persentase",
                amount: "Jumlah",
                comp_100: "GRATIS (100%)",
                old_total: "Total Lama",
                new_total: "Total Baru",
                apply: "Terapkan Diskon"
            }
        },
        payment: {
            alerts: {
                enter_valid: "Silakan masukkan jumlah yang valid.",
                balance_not_zero: "Sisa saldo harus 0 untuk menutup tiket."
            },
            header_order: "Pesanan",
            header_open: "Buka Tiket",
            ticket_details: "Detail Tiket",
            select_all: "Pilih Semua",
            items_count: "{{count}} Barang",
            empty_list: "Tidak Ada Barang",
            remaining_badge: "Sisa: {{amount}}",
            recent_transactions: "TRANSAKSI TERBARU",
            totals: {
                total: "Total",
                paid: "Dibayar",
                remaining: "Sisa"
            },
            amount_to_collect: "Jumlah yang Harus Diambil",
            give_change: "Kembalian",
            return_to_customer: "Kembalikan ke Pelanggan",
            methods: {
                cash: "Tunai",
                card: "Kartu Kredit",
                qr: "QR / Seluler",
                other: "Kartu Makan"
            },
            numpad: {
                all: "Semua"
            },
            actions: {
                cancel: "Batal",
                close_ticket: "Tutup Tiket",
                waiting_payment: "Menunggu Pembayaran"
            }
        },
        menu: {
            title: "Manajemen Menu",
            subtitle: "Kelola produk, harga, dan stok",
            add_new: "Tambah Produk",
            edit_title: "Ubah Produk",
            add_title: "Tambah Produk",
            manage_categories: "Kelola Kategori",
            alerts: {
                no_permission: "Anda tidak memiliki izin untuk mengelola menu.",
                delete_confirm: "Apakah Anda yakin ingin menghapus produk ini?"
            },
            form: {
                image_select: "Pilih Gambar",
                image_change: "Ganti Gambar",
                image_recommendation: "Format persegi disarankan",
                image_max_size: "Maks 2MB",
                name: "Nama Produk",
                name_placeholder: "misal: Latte",
                category: "Kategori",
                price: "Harga",
                stock_tracking: "Pelacakan Stok",
                stock_hint: "Isi 0 untuk menonaktifkan",
                description: "Deskripsi",
                description_placeholder: "Bahan-bahan, detail...",
                customizable: "Dapat Dimodifikasi"
            },
            categories: {
                title: "Manajemen Kategori",
                add: "Tambah Kategori",
                name: "Nama Kategori",
                edit: "Ubah Kategori",
                delete_confirm: "Hapus kategori ini?"
            }
        },
        categories: {
            all: "Semua",
            hot_coffees: "Kopi Panas",
            cold_coffees: "Kopi Dingin",
            desserts: "Makanan Penutup",
            snacks: "Camilan",
            barista_special: "Spesial"
        },
        stock: {
            title: "Manajemen Inventaris",
            subtitle: "Stok, Resep, dan Modifikasi",
            tabs: {
                inventory: "Inventaris",
                recipes: "Resep",
                modifiers: "Modifikasi"
            },
            inventory: {
                total_value: "Total Nilai",
                sku_count: "Jumlah SKU",
                alerts: "Peringatan Stok",
                search_placeholder: "Cari Stok...",
                add_stock: "Tambah Barang",
                status_critical: "Kritis",
                status_warning: "Rendah",
                status_sufficient: "OK",
                table: {
                    name: "Nama",
                    supplier: "Pemasok",
                    amount: "Jumlah",
                    status: "Status",
                    unit_cost: "Biaya Satuan",
                    actions: "Tindakan"
                },
                modal: {
                    edit_title: "Ubah Stok",
                    add_title: "Tambah Stok",
                    general_info: "Info Umum",
                    management: "Manajemen",
                    name: "Nama Barang",
                    name_placeholder: "misal: Susu",
                    supplier: "Pemasok",
                    supplier_placeholder: "misal: Peternakan Lokal",
                    unit: "Satuan",
                    alarm_thresholds: "Ambang Batas Alarm",
                    warning_limit: "Batas Peringatan",
                    critical_limit: "Batas Kritis",
                    stock_status: "Status Stok",
                    finish_editing: "Selesai Mengubah",
                    manual_correction: "Koreksi Manual",
                    current_amount: "Jumlah Saat Ini",
                    unit_cost: "Biaya Satuan",
                    new_purchase: "Pembelian / Input Baru",
                    add_amount: "Tambah Jumlah",
                    purchase_price: "Harga Beli",
                    total: "Total",
                    unit_price: "Harga Satuan",
                    success_feedback: "Diperbarui!",
                    calculate_add: "Hitung & Tambah",
                    avg_cost_note: "* Menghitung biaya rata-rata tertimbang."
                }
            },
            wastage: {
                title: "Laporkan Pembuangan",
                subtitle: "Melaporkan pembuangan untuk {{name}}",
                amount: "Jumlah",
                reason: "Alasan",
                reason_placeholder: "misal: Tumpah, Busuk",
                report: "Laporkan Pembuangan"
            },
            recipes: {
                search_product: "Cari produk...",
                gross_margin: "Margin Kotor",
                sale_price: "Harga Jual",
                cost_price: "Harga Pokok",
                ingredients: "Bahan-bahan",
                no_recipe: "Tidak ada resep yang ditentukan.",
                add_ingredient: "Tambah Bahan",
                stock_item: "Barang Stok",
                amount: "Jumlah",
                unit: "Satuan"
            },
            modifiers: {
                title: "Grup Modifikasi",
                new_group: "Grup Baru",
                group_name: "Nama Grup",
                selection_type: "Tipe Pemilihan",
                single: "Tunggal (Radio)",
                multiple: "Beberapa (Checkbox)",
                options: "Pilihan",
                option_name: "Nama Pilihan",
                option_placeholder: "misal: Susu Gandum",
                extra_price: "Harga Tambahan",
                deduct_stock: "Potong Stok (Opsional)",
                add_option: "Tambah Pilihan",
                group_helper_text: "Kelola pilihan untuk grup ini di bawah.",
                no_link: "Tanpa Tautan",
                stock_optional_label: "Stok (Opsional)",
                edit_group_title: "Ubah Grup",
                allow_multiple_label: "Izinkan beberapa pilihan (Checkbox)",
                delete_group_confirm: "Apakah Anda yakin ingin menghapus grup ini?"
            }
        },
        reports: {
            title: "Ikhtisar Keuangan",
            filters: { today: "Hari Ini", week: "Minggu", month: "Bulan", all: "Semua" },
            kpi: {
                revenue: "Total Pendapatan",
                net_revenue: "Pendapatan Bersih (Tanpa Pajak)",
                tax_collected: "Pajak Terkumpul",
                income: "Pemasukan",
                expense: "Total Pengeluaran",
                expense_opr: "Operasional",
                expense_stock: "COGS",
                expense_wastage: "Pembuangan",
                profit: "Laba Bersih",
                profit_opr: "Laba Operasional",
                cash_in_hand: "Arus Kas",
                gross_profit: "Laba Kotor",
                tickets: "Total Tiket",
                sales_count: "Jumlah Penjualan",
                expense_analysis: "Analisis Pengeluaran",
                profit_analysis: "Analisis Laba Bersih",
                available_in_standard: "Tersedia di Paket Standar",
                locked: "Terkunci"
            },
            toggles: {
                stock_cost: "Biaya Stok",
                wastage: "Pembuangan",
                operational: "Mode Operasional",
                net_revenue: "Pendapatan Bersih (Pajak)"
            },
            charts: {
                sales_title: "Grafik Penjualan ({{currency}})",
                hourly: "Per Jam",
                daily: "Harian",
                monthly: "Bulanan",
                distribution: "Distribusi",
                category_breakdown: "Rincian Kategori",
                revenue_share: "Bagi Hasil Pendapatan",
                no_data: "Tidak ada data.",
                tooltip_revenue: "Pendapatan: ",
                tooltip_net_revenue: "Pendapatan Bersih: ",
                tooltip_profit: "Laba: "
            },
            transactions: {
                title: "Riwayat Transaksi",
                count_listed: "{{count}} Catatan Terdaftar",
                table: {
                    ticket_no: "No Tiket",
                    date: "Tanggal / Waktu",
                    table: "Meja",
                    method: "Metode",
                    amount: "Jumlah",
                    status: "Status"
                },
                status: {
                    completed: "Selesai",
                    cancelled: "Dibatalkan"
                },
                no_records: "Tidak ada transaksi dalam rentang yang dipilih."
            },
            x_report: {
                title: "Laporan Kas Instan (Laporan X)",
                total_cash: "Total Tunai di Laci Kas",
                daily_tickets: "Tiket Harian",
                cancelled_trx: "Transaksi Dibatalkan",
                collections: "Koleksi (Saat Ini)",
                shift_reports: "Laporan Shift Staf (Hari Ini)",
                no_shift: "Belum ada laporan shift.",
                total_sales: "TOTAL PENJUALAN",
                cash: "Tunai",
                credit_card: "Kartu Kredit",
                qr_mobile: "QR / Seluler",
                meal_card: "Kartu Makan"
            },
            z_report: {
                title: "Laporan Akhir Hari (Laporan Z)",
                auto_toggle: "Laporan Z Otomatis",
                auto_desc: "Pukul 00:00",
                close_button: "TUTUP HARI (LAPORAN Z)",
                history_title: "Laporan Z Masa Lalu",
                no_reports: "Belum ada laporan.",
                receipt: {
                    title: "LAPORAN Z",
                    report_no: "No Laporan",
                    cashier: "Kasir",
                    total_sales: "TOTAL PENJUALAN",
                    tax_base: "Dasar Pajak",
                    total_tax: "Total Pajak",
                    payment_details: "Detail Pembayaran",
                    cash: "Tunai",
                    card: "Kartu Kredit",
                    other: "Lainnya",
                    end: "--- SELESAI ---"
                }
            },
            modals: {
                close_confirm: {
                    title: "Tutup Hari?",
                    text: "Tindakan ini akan mengarsipkan <strong>{{count}}</strong> transaksi terbuka dan menghasilkan Laporan Z resmi. Tidak dapat dibatalkan.",
                    cancel: "Batal",
                    confirm: "Konfirmasi & Tutup"
                },
                expense: {
                    title: "Tambah Pengeluaran Cepat",
                    date: "Tanggal",
                    category: "Kategori",
                    amount: "Jumlah",
                    description: "Deskripsi",
                    optional: "Opsional...",
                    set_default: "Atur sebagai default untuk kategori",
                    last_trx: "Terakhir: {{amount}} ({{date}})"
                },
                processing: {
                    title: "Menghasilkan Laporan Z...",
                    text: "Mohon tunggu, memproses akhir hari..."
                }
            },
            liabilities: {
                pending: "Pembayaran Tertunda",
                label_today: "Bagi Biaya Hari Ini",
                label_week: "Bagi Biaya Mingguan",
                label_total: "Pembayaran Berulang Tertunda"
            }
        },
        settings: {
            general: "Pengaturan Umum",
            titles: {
                general: "Umum",
                expenses: "Pengeluaran",
                modifiers: "Modifikasi",
                developer: "Pengembang"
            },
            descriptions: {
                general: "Sistem, bahasa, dan pengaturan bisnis",
                expenses: "Konfigurasi keuangan",
                developer: "Alat untuk simulasi dan pengujian"
            },
            subscription: {
                active: "AKTIF",
                inactive: "TIDAK AKTIF",
                expired: "KADALUARSA",
                renew: "Perbarui",
                days_left: "Hari Tersisa",
                next_payment: "Pembayaran Berikutnya",
                period_start: "Awal Periode",
                time_remaining: "Sisa Waktu",
                lite_plan: "Paket Lite",
                standard_plan: "Paket Standar"
            },
            business_identity: "Identitas Bisnis",
            financial: "Pengaturan Keuangan",
            financial_desc: {
                currency_desc: "Simbol yang digunakan di seluruh sistem",
                pricing_desc: "Metode perhitungan pajak"
            },
            interface: {
                title: "Antarmuka",
                scale: "Skala UI (Zoom)",
                scale_desc: "Sesuaikan skala untuk barang yang tidak pas atau tampak terlalu kecil/besar.",
                note: "Catatan:",
                scale_note: "Auto-scaling selalu aktif pada layar yang lebih kecil dari 1366px."
            },
            operational: {
                title: "Jam Kerja & Shift",
                start_hour: "Jam Mulai (0-23)",
                end_hour: "Jam Selesai (0-23)",
                info_text: "Pengaturan ini menentukan rentang waktu yang ditampilkan pada grafik penjualan per jam di **Dasbor** saat 'Jam Kerja' dipilih. Ini juga digunakan sebagai referensi untuk laporan shift staf.",
                updated_alert: "Jam kerja diperbarui."
            },
            shortcuts: {
                staff_desc: "Kelola Pelayan, Barista, dan Admin"
            },
            backup: {
                title: "Data & Cadangan",
                backup_now: "Cadangkan",
                backup_desc: "Unduh Database (.json)",
                restore: "Pulihkan",
                restore_desc: "Pilih File .json",
                factory_reset: "Kembali ke Setelan Pabrik",
                reset_desc: "Semua data akan dihapus dan dikembalikan ke keadaan awal.",
                reset_button: "Reset Data",
                success_restore: "Cadangan berhasil dipulihkan."
            },
            security: {
                reset_title: "Kembali ke Setelan Pabrik",
                restore_title: "Pulihkan dari Cadangan",
                reset_text: "Tindakan ini tidak dapat dibatalkan. Semua data (penjualan, produk, stok) akan dihapus secara permanen.",
                restore_text: "Data saat ini akan dihapus dan data dari file cadangan yang dipilih akan dimuat.",
                admin_required: "Persetujuan Admin Diperlukan",
                enter_pin: "Silakan masukkan PIN",
                confirm_reset: "Hapus & Reset",
                confirm_restore: "Mulai Pemulihan"
            },
            messages: {
                updated: "Pengaturan diperbarui.",
                error: "Terjadi kesalahan."
            },
            sync: {
                title: "Cloud Sync",
                pending: "{{count}} barang tertunda",
                up_to_date: "Semua data sudah terbaru",
                button: "Sinkronkan Sekarang"
            }
        },
        financials: {
            title: "Pengaturan Keuangan",
            subtitle: "Tarif Pajak & Kategori Pengeluaran",
            tabs: {
                taxes: "Pajak",
                expenses: "Pengeluaran",
                history: "Riwayat Pengeluaran"
            },
            taxes: {
                title: "Tarif Pajak",
                active_rates: "Tarif Aktif",
                rate_name: "Nama Tarif",
                rate_percent: "Tarif %",
                description: "Deskripsi",
                add_new: "Tambah Tarif Baru",
                category_mapping: "Pemetaan Pajak Kategori"
            },
            expenses: {
                title: "Kategori Pengeluaran",
                add_new: "Tambah Kategori",
                category_name: "Nama Kategori",
                description: "Deskripsi",
                default_amount: "Jumlah Default",
                recurring: "Berulang (Bulanan)",
                recurring_day: "Hari dalam Sebulan",
                distribute_daily: "Distribusikan Harian dalam Laporan"
            },
            history: {
                title: "Riwayat Pengeluaran",
                filter_all: "Semua Kategori",
                no_records: "Tidak ada catatan ditemukan.",
                table: {
                    date: "Tanggal",
                    category: "Kategori",
                    description: "Deskripsi",
                    amount: "Jumlah"
                }
            }
        },
        crm: {
            title: "CRM & Loyalitas",
            subtitle: "Manajemen Pelanggan & Program Loyalitas",
            give_points: "Berikan Poin",
            qr_instruction: "Scan kode QR untuk pelanggan",
            generate_qr: "Buat QR",
            qr_description: "Tunjukkan kode QR ini kepada pelanggan untuk menambahkan poin ke dompet mereka.",
            customer_list: "Daftar Pelanggan",
            search_placeholder: "Cari Pelanggan...",
            last_visit: "Kunjungan Terakhir:",
            eligible: "Hadiah Tersedia!",
            settings_title: "Pengaturan Kampanye",
            target_points: "Target Poin",
            reward_name: "Nama Hadiah",
            preview: "Pratinjau Kartu",
            target_label: "Target",
            coming_soon: "Segera Hadir"
        },
        qr: {
            title: "Menu QR",
            subtitle: "Sistem Menu Digital & Pemesanan",
            simulate: "Simulasi Pesanan",
            print_selected: "Cetak yang Dipilih",
            lock: {
                title: "Layanan Online Terkunci",
                desc: "Menu QR dan fitur pemesanan online tersedia di Paket Standar.",
                upgrade_btn: "Tingkatkan Paket"
            },
            print: {
                title: "Cetak Kode QR",
                scan_instruction: "Scan untuk Melihat Menu"
            },
            preview: {
                title: "Pratinjau Langsung",
                network: "Jaringan:",
                password: "Sandi:",
                powered_by: "Didukung oleh KahveInn",
                disclaimer: "* Ini adalah pratinjau tampilan stand QR.",
                scan_instruction: "Scan untuk Menu"
            },
            settings: {
                general: "Umum",
                active: "Aktif",
                active_desc: "Aktifkan sistem Menu QR",
                ordering: "Izinkan Pemesanan",
                ordering_desc: "Pelanggan dapat melakukan pesanan",
                sound: "Peringatan Suara",
                sound_desc: "Putar suara pada pesanan baru",
                design: "Desain",
                header_text: "Teks Judul",
                theme_color: "Warna Tema",
                wifi_ssid: "Wi-Fi SSID",
                wifi_pass: "Kata Sandi Wi-Fi"
            },
            selection: {
                title: "Pemilihan Meja",
                select_all: "Pilih Semua",
                previewing: "Pratinjau"
            },
            modal: {
                permission_title: "Izin Diperlukan",
                permission_text: "Kami memerlukan izin browser untuk memutar notifikasi suara.",
                allow_btn: "Izinkan Suara"
            }
        },
        staff: {
            title: "Manajemen Staf",
            subtitle: "Karyawan dan otorisasi",
            tabs: {
                list: "Daftar Staf",
                roles: "Peran & Izin"
            },
            lite_banner: {
                title: "Paket Lite",
                desc: "Manajemen staf tingkat lanjut dibatasi."
            },
            stats: {
                total: "Total Staf",
                on_duty: "Sedang Bertugas"
            },
            matrix: {
                person: "Orang"
            },
            auto_shift_report: "Laporan Shift Otomatis",
            modal: {
                add_title: "Tambah Staf",
                edit_title: "Ubah Staf",
                delete: "Hapus Staf",
                name: "Nama Lengkap",
                role: "Peran",
                pin: "Kode PIN (4 digit)",
                phone: "Telepon (Opsional)",
                status: "Status",
                status_working: "Bekerja",
                status_off: "Selesai Tugas"
            },
            roles_tab: {
                title: "Peran",
                subtitle: "Sesuaikan izin peran",
                permissions: "Izin",
                no_permissions: "Tidak ada izin yang diberikan"
            },
            contact: "Kontak",
            status: {
                working: "Bekerja",
                offline: "Selesai Tugas"
            },
            permission_matrix: "Matriks Izin",
            no_pin_permission: "Tidak ada izin untuk melihat/mengubah PIN",
            unauthorized_tooltip: "Anda tidak dapat mengubah pengguna ini",
            alerts: {
                no_add_permission: "Anda tidak memiliki izin untuk menambah staf.",
                no_edit_others: "Anda hanya dapat mengubah profil Anda sendiri.",
                no_edit_admin: "Hanya Admin yang dapat mengubah Admin.",
                no_delete_self: "Anda tidak dapat menghapus diri sendiri.",
                no_delete_permission: "Anda tidak memiliki izin untuk menghapus staf.",
                no_delete_admin: "Hanya Admin yang dapat menghapus Admin.",
                delete_confirm: "Apakah Anda yakin ingin menghapus anggota staf ini?",
                no_status_admin: "Hanya Admin yang dapat mengubah status Admin.",
                only_admin_roles: "Hanya Admin yang dapat mengubah izin peran."
            }
        },
        permission_groups: {
            general: "Umum",
            sales: "Penjualan",
            management: "Manajemen"
        },
        permissions: {
            VIEW_FINANCIALS: { label: "Lihat Keuangan", description: "Akses data pendapatan dan laba" },
            VIEW_TABLES: { label: "Lihat Meja", description: "Lihat denah meja dan pesanan" },
            MANAGE_MENU: { label: "Kelola Menu", description: "Tambah dan ubah produk" },
            MANAGE_STOCK: { label: "Kelola Stok", description: "Kontrol inventaris" },
            VIEW_REPORTS: { label: "Lihat Laporan", description: "Akses halaman laporan" },
            MANAGE_STAFF: { label: "Kelola Staf", description: "Tambah/hapus staf" },
            MANAGE_SETTINGS: { label: "Kelola Pengaturan", description: "Konfigurasi sistem" },
            VOID_ITEM: { label: "Void Barang", description: "Operasi pembatalan atau pembuangan" },
            OFFER_COMP: { label: "Berikan Gratis", description: "Izin untuk memberikan barang gratis" },
            APPLY_DISCOUNT: { label: "Terapkan Diskon", description: "Terapkan diskon pada pesanan" },
            CLOSE_DAY: { label: "Tutup Hari", description: "Izin untuk mengambil Laporan Z" }
        },
        setup: {
            business_name: "Nama Bisnis",
            business_address: "Alamat",
            manager_name: "Nama Manajer",
            manager_hint: "Nama Anda untuk profil manajer",
            staff_count: "Jumlah Staf",
            staff_hint: "Estimasi jumlah karyawan",
            currency: "Mata Uang",
            pricing_model: "Model Harga",
            tax_inclusive: "Termasuk Pajak",
            tax_exclusive: "Belum Termasuk Pajak",
            completing: "Menyelesaikan Penyiapan...",
            title_1: "Selamat Datang",
            title_2: "Tim & Manajemen",
            title_3: "Pengaturan Keuangan",
            desc_1: "Mari buat identitas bisnis Anda.",
            desc_2: "Mari konfigurasi struktur tim Anda.",
            desc_3: "Pilih preferensi mata uang dan pajak Anda.",
            skip_dev: "Lewati (Dev)",
            back: "Kembali",
            next: "Berikutnya",
            finish: "Selesaikan Penyiapan",
            placeholders: {
                business_name: "misal: KahveInn",
                city: "Kota (misal: Jakarta)",
                district: "Kecamatan (misal: Menteng)",
                address_detail: "Jalan, No. Gedung...",
                manager_name: "Nama Lengkap Anda"
            },
            errors: {
                business_name: "Silakan masukkan nama bisnis.",
                city: "Silakan masukkan kota.",
                district: "Silakan masukkan kecamatan.",
                address_detail: "Silakan masukkan alamat lengkap.",
                manager_name: "Silakan masukkan nama manajer.",
                staff_count: "Silakan masukkan jumlah staf yang valid."
            },
            currencies: {
                try: "Lira Turki (₺)",
                usd: "$ - Dolar AS ($)",
                eur: "Euro (€)",
                gbp: "Pound Sterling (£)"
            },
            loading_text: "Sistem Anda sedang disiapkan, mohon tunggu."
        }
    }
};